/**
 * search_suggestion_text.js
 * -------------------------
 * The text a store search suggestion shows under the store name (CL-23): the store's top
 * offer for the member, or the cash back rate when there is no offer. Shared by the nav
 * overlay (shop_nav_wiring.js) and the search bar (shop-search-bar.js) so the two surfaces
 * cannot drift apart.
 *
 * `store` is one entry of the `results` array from `/stores.json`. `offer` and `cashBack` are
 * empty strings when they do not apply; `subtitle` is the offer, falling back to the cash back
 * rate, and is empty when the store has neither.
 */
export function suggestionText(store) {
  const offer =
    typeof store.top_offer_title === "string"
      ? store.top_offer_title.trim()
      : "";
  const cashBack =
    store.has_cash_back && store.cash_back
      ? `${store.cash_back} cash back`
      : "";
  return { offer, cashBack, subtitle: offer || cashBack };
}
